var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpSymbolikuvitus128054(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2,.cls-3,.cls-4{fill:none;}.cls-2{opacity:0.2;}.cls-3{stroke:#6e6e6e;}.cls-3,.cls-4{stroke-linecap:round;stroke-miterlimit:10;stroke-width:1.25px;}.cls-4{stroke:#ff6a10;}.cls-5{fill:#6d6e70;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 128,
    height: 128
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 128,
    height: 128
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M104.29,121.6H23.71a1.36,1.36,0,0,1-1.36-1.36V25.85a1.36,1.36,0,0,1,1.36-1.36H36.22a1.36,1.36,0,0,0,1.36-1.36V7.76A1.36,1.36,0,0,1,38.94,6.4h65.35a1.36,1.36,0,0,1,1.36,1.36V120.24A1.36,1.36,0,0,1,104.29,121.6Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 22.78,
    y1: 24.77,
    x2: 37.58,
    y2: 7.28
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 76.12,
    y1: 45.68,
    x2: 94.47,
    y2: 45.68
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 32.58,
    y1: 45.68,
    x2: 67.91,
    y2: 45.68
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 76.12,
    y1: 61.74,
    x2: 94.47,
    y2: 61.74
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 60.95,
    y1: 61.74,
    x2: 67.91,
    y2: 61.74
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 32.58,
    y1: 61.74,
    x2: 52.75,
    y2: 61.74
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 91.28,
    y1: 77.81,
    x2: 94.47,
    y2: 77.81
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 76.12,
    y1: 77.81,
    x2: 83.08,
    y2: 77.81
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 60.95,
    y1: 77.81,
    x2: 67.91,
    y2: 77.81
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 45.79,
    y1: 77.81,
    x2: 52.75,
    y2: 77.81
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 32.58,
    y1: 77.81,
    x2: 37.58,
    y2: 77.81
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 32.58,
    y1: 93.88,
    x2: 94.47,
    y2: 93.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 37.59,
    y: 66.05,
    width: 8.2,
    height: 27.57,
    rx: 1.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 52.75,
    y: 52.71,
    width: 8.2,
    height: 40.91,
    rx: 1.56
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M75.4,93.62H68.63a.72.72,0,0,1-.72-.72V39.2a.72.72,0,0,1,.72-.72H75.4a.72.72,0,0,1,.72.72V92.9A.72.72,0,0,1,75.4,93.62Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 83.08,
    y: 68.08,
    width: 8.2,
    height: 25.55,
    rx: 1.56
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M72,35.43h0a.45.45,0,0,1-.43-.46V26.81c0-4.11,8.25-4.84,8.6-4.87a.43.43,0,0,1,.36.13.42.42,0,0,1,.13.36c0,.23-.53,5.43-4.42,6.52-3.28.92-3.76,6-3.76,6.06A.46.46,0,0,1,72,35.43Zm7.65-12.52c-2.44.3-7.19,1.4-7.19,3.9v4.65A5.7,5.7,0,0,1,76,28.07C78.59,27.34,79.43,24.2,79.66,22.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M72,29.79a.46.46,0,0,1-.45-.42c0-.05-.48-5.14-3.76-6.06-3.89-1.09-4.41-6.3-4.43-6.52a.46.46,0,0,1,.14-.36.43.43,0,0,1,.36-.13c.35,0,8.6.76,8.6,4.87v8.16a.46.46,0,0,1-.44.46ZM64.37,17.27c.24,1.29,1.07,4.43,3.68,5.16a5.65,5.65,0,0,1,3.51,3.39V21.17C71.56,18.66,66.81,17.57,64.37,17.27Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpSymbolikuvitus128054);
export default __webpack_public_path__ + "static/media/OP_symbolikuvitus_128_054.c268943b616ea914e935c41e364f9dba.svg";
export { ForwardRef as ReactComponent };